import { render, staticRenderFns } from "./sso-classlink.vue?vue&type=template&id=5ed32487&scoped=true&"
import script from "./sso-classlink.ts?vue&type=script&lang=ts&"
export * from "./sso-classlink.ts?vue&type=script&lang=ts&"
import style0 from "./sso-classlink.scss?vue&type=style&index=0&id=5ed32487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed32487",
  null
  
)

export default component.exports